import React, { useContext } from "react";

import classnames from "classnames";
import PropTypes from "prop-types";

import { BootstrapContext, SearchContext } from "components/store/source";
import { setDatepickerDates } from "components/store/source/actions/searchCriteriaActions";
import { DateRangePickerInput } from "components/ui/source/components/DatePickerV2/DateRangePickerInput";

import { useMinNights } from "../../useMinNights";

import styles from "./CollectionsDatePicker.module.scss";

function CollectionsDatePicker({ className }) {
  const {
    criteria: { guests, checkIn, checkOut },
    dispatch,
  } = useContext(SearchContext);
  const {
    urlParams: { id },
  } = useContext(BootstrapContext);

  const { loading, minNights, onPrevMonthClick, onNextMonthClick } =
    useMinNights({
      id,
      checkInDate: checkIn,
      guestCount: guests?.guests || 1,
    });

  // Get minimum of collections minStayLength
  const getMinimumStayLength = checkInDate => {
    const minNightForDate = minNights.find(
      minNight => minNight.date === checkInDate,
    );
    return minNightForDate?.minimumStayLength ?? 2;
  };

  // Update Search criteria when date changes
  const handleDatesChange = ({ startDate, endDate }) => {
    dispatch(
      setDatepickerDates({
        checkIn: startDate,
        checkOut: endDate,
      }),
    );
  };

  return (
    <div className={classnames(styles.container, className)}>
      <DateRangePickerInput
        className={styles.datePickerInput}
        datePickerClassName={styles.datePickerContainer}
        disabled={loading}
        startDate={checkIn}
        endDate={checkOut}
        onDatesChanged={({ startDate, endDate }) => {
          handleDatesChange({ startDate, endDate });
        }}
        minNights={getMinimumStayLength(checkIn)}
        onNextMonthClick={onNextMonthClick}
        onPreviousMonthClick={onPrevMonthClick}
      />
    </div>
  );
}

CollectionsDatePicker.propTypes = {
  className: PropTypes.string,
};

export default CollectionsDatePicker;
